/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Represents the direction of a message.
 */
export enum MessageDirection {
  INBOUND = "Inbound",
  OUTBOUND = "Outbound",
}
